import React from "react";
import Seo from "@/components/site/Seo";
import Band, { Eyebrow } from "@/components/site/Band";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-2xl text-spruce mb-3">{title}</h2>
    <div className="space-y-3 text-base text-ink/85 leading-relaxed">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms"
        description="Terms of use for the Health and More website, including the limits of the illustrative estimates shown in the economics calculator."
        path="/terms"
      />
      <Band tone="spruce">
        <Eyebrow>Terms</Eyebrow>
        <h1 className="font-display text-4xl sm:text-5xl leading-[1.03] max-w-3xl">Terms of use</h1>
      </Band>
      <Band tone="bone">
        <div className="max-w-prose">
          <Section title="Informational only">
            <p>
              This website describes programs that Health and More helps independent practices join
              through hospital-system partners. It is informational and is not an offer, a contract, or a
              guarantee of any particular result.
            </p>
          </Section>
          <Section title="Illustrative estimates">
            <p>
              The calculator on this site produces illustrative estimates based on assumptions you can see
              and change on the screen. These figures are not a promise of savings or revenue. Actual
              results depend on payer mix, documentation, patient engagement, drug pricing set by
              manufacturers and HRSA, and the specific covered-entity arrangement.
            </p>
          </Section>
          <Section title="340B eligibility">
            <p>
              340B eligibility is held by covered entities — our hospital partners. Nothing on this site
              should be read to imply that a private practice becomes a covered entity or independently
              qualifies for 340B pricing.
            </p>
          </Section>
          <Section title="Clinical authority">
            <p>
              Practices that work with us retain full clinical authority. We provide administrative
              services only and are not involved in clinical decision-making.
            </p>
          </Section>
          <p className="text-sm text-sage mt-8">
            This page is written in plain language and is not legal advice.
          </p>
        </div>
      </Band>
    </>
  );
}
